import React, { useContext, useEffect, useState } from "react";
import DashboardContainer from "../Container";
import { TimeBookingContext } from "../../../context/TimebookingContext";
import { ITsZeitFerienInfos, requestZeitFerienInfos } from "../../Timesafe/timesafeApiCalls";
import "../style-lists.scss";

function formatMinutes(min: number): string {
    const sign = min < 0 ? "-" : "";
    const abs = Math.abs(min);
    return `${sign}${Math.floor(abs / 60)}:${(abs % 60).toString().padStart(2, "0")}`;
}

function formatDate(datum: string): string {
    const date = new Date(datum);
    return isNaN(date.getTime()) ? "" : date.toLocaleDateString("de-CH");
}

// Time and holiday balance of the signed in user from TimeSafe (current year until today)
function ContainerTimesafeInfo(props: { classes: string }) {
    const { isActive } = useContext(TimeBookingContext);
    const [infos, setInfos] = useState<ITsZeitFerienInfos | null>(null);
    const [laden, setLaden] = useState<boolean>(true);
    const [fehler, setFehler] = useState<string>("");

    // Load on start and reload when clocking in/out (the balance changes with a new booking)
    useEffect(() => {
        requestZeitFerienInfos()
            .then((daten) => {
                setInfos(daten);
                setFehler("");
            })
            .catch((error) => {
                console.error(error);
                setFehler(`Saldi konnten nicht geladen werden: ${error?.message ?? error}`);
            })
            .finally(() => setLaden(false));
    }, [isActive]);

    const zeile = (label: string, wert: string) => (
        <div className="ds-info__row">
            <span>{label}</span>
            <span className="ds-info__value">{wert}</span>
        </div>
    );

    let inhalt: React.ReactNode;
    if (fehler) inhalt = <div className="ds-list__empty ds-list__error">{fehler}</div>;
    else if (laden) inhalt = <div className="ds-list__empty">Saldi werden geladen ...</div>;
    else if (!infos) inhalt = <div className="ds-list__empty">Keine Saldi vorhanden</div>;
    else
        inhalt = (
            <>
                {zeile("Zeitsaldo:", `${infos.zeitsaldoInHHMM || formatMinutes(infos.zeitsaldoInMinuten)} h`)}
                {/* feriensaldoFormatiert comes as "days × hours per day", the plain days are clearer */}
                {zeile("Feriensaldo:", `${infos.feriensaldoInTagen.toFixed(1)} Tage`)}
                {/* TimeSafe only has a target time (Soll) if it is configured for the employee */}
                {infos.istzeitInHHMM &&
                    (infos.sollzeitInMinuten
                        ? zeile("Ist / Soll (Jahr):", `${infos.istzeitInHHMM} / ${infos.sollzeitInHHMM} h`)
                        : zeile("Ist (Jahr):", `${infos.istzeitInHHMM} h`))}
                <div className="ds-info__stand">Stand {formatDate(infos.bisDatum)}</div>
            </>
        );

    return (
        <DashboardContainer headerName="TIMESAFE INFOS" className={`ds-list ds-timesafeinfo ${props.classes}`}>
            {inhalt}
        </DashboardContainer>
    );
}

export default ContainerTimesafeInfo;
